import {NgModule} from '@angular/core';
import {ImageService} from '../../../../../../../../shared/services/advtech/image';
import {ImagePreviewService} from '../../../../../../services/image-preview';
import {ImageSearch} from '../../../../../../services/image-search';
import {ImageShortcodeToolbarActionSheet} from '../../../../../action-sheet/image-shortcode-toolbar';
import {ImageUploadModule} from '../../../../../image-upload/image-upload.component.module';

import {ImageQuillToolbarButtonComponent} from './index';

/**
 * Module for the ImageQuillToolbarButtonModule
 * @class
 */
@NgModule({
  declarations: [ImageQuillToolbarButtonComponent],
  exports: [ImageQuillToolbarButtonComponent],
  imports: [ImageUploadModule],
  providers: [ImageShortcodeToolbarActionSheet, ImageSearch, ImageService, ImagePreviewService],
})
export class ImageQuillToolbarButtonModule {
}



// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/quill-toolbar/buttons/image-quill-toolbar-button/image-quill-toolbar-button.component.module.ts